import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface DoubleCheckIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const DoubleCheckIcon = ({ className, ...props }: DoubleCheckIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4698 6.46979C21.7627 6.17689 22.2374 6.17689 22.5303 6.46979C22.8232 6.76269 22.8232 7.23746 22.5303 7.53033L12.9551 17.1065C12.428 17.6337 11.5722 17.6337 11.045 17.1065L8.99908 15.0606L6.95514 17.1065C6.42795 17.6337 5.5722 17.6337 5.04498 17.1065L0.969788 13.0303C0.676894 12.7374 0.676894 12.2627 0.969788 11.9698C1.26268 11.6769 1.73744 11.6769 2.03033 11.9698L6.00006 15.9385L7.93854 14.0001L6.46979 12.5303C6.17689 12.2374 6.17689 11.7627 6.46979 11.4698C6.76268 11.1769 7.23744 11.1769 7.53033 11.4698L11.9991 15.9385L21.4698 6.46979ZM15.4698 6.46979C15.7627 6.17689 16.2374 6.17689 16.5303 6.46979C16.8232 6.76269 16.8232 7.23746 16.5303 7.53033L12.5303 11.5303C12.2375 11.8232 11.7627 11.8232 11.4698 11.5303C11.1769 11.2374 11.1769 10.7627 11.4698 10.4698L15.4698 6.46979Z"
      fill="currentColor"
    />
  </svg>
);

export default DoubleCheckIcon;
